import React from "react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import logo from "../assets/logo.png";

export const Footer = (props) => {
  return (
    <>
      <footer className="footer-container">
        <div className="footer-overlay"></div>
        <div className="footer-content">
          <div className="footer-section company-info">
            <img src={logo} alt="logo" height={100} />
            <p style={{marginTop: "20px"}}>
              We deliver the most advanced information and communication 
              technology solutions to help your business grow and become 
              more efficient.
            </p>
          </div>

          <div className="footer-section">
            <h3>Our Company</h3>
            <ul>
              <li>Partners</li>
              <li>Careers</li>
              <li>About Us</li>
              <li>Blog</li>
              <li>Contact Us</li>
              <li>General Terms & Conditions</li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Our Services</h3>
            <ul>
                <div className="row">
                    <div className="col-md-6">
                        <li>Backup & Disaster Recovery</li>
                        <li>Network Infrastructure & Security</li>
                        <li>Datacenter Solutions</li>
                        <li>CCTV</li>
                        <li>Biometrics</li>
                        <li>Unified Communications</li>
                        <li>End user computing devices</li>
                        <li>Virtual Machines</li>
                        <li>Mobility</li>
                        <li>Unified Communication</li>
                    </div>
                    <div className="col-md-6">
                        <li>ERP</li>
                        <li>CRM</li>
                        <li>Mobile Applications</li>
                        <li>Web Portals</li>
                        <li>EDMS</li>
                        <li>USSD, BulkSMS, & ChatBots</li>
                        <li>Analytics & Reporting</li>
                        <li>Virtual Machines</li>
                        <li>Cloud Services</li>
                    </div>
                </div>
            </ul>
          </div>

          <div className="footer-section contact-us">
            <h3>Contact Us</h3>
            <div className="subscribe">
              <input type="email" placeholder="Your email address" />
              <button>SUBSCRIBE</button>
            </div>
            <p><FaPhone /> +254 795 022 244</p>
            <p><FaEnvelope /> info@infrasoft.co.ke</p>
            <p><FaMapMarkerAlt /> National Water Plaza, Ground Floor, Dunga Rd.</p>
          </div>
        </div>
      </footer>

      {/* Lower section (copyright) moved outside the footer */}
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()}. All rights reserved. 
        </p>
      </div>
    </>
  );
};
